import { DateTime } from "luxon";

import { readingTimeLabel, summarizeHtml } from "./html-text";

/*************************** TIMEZONE Constants (from holidayUtilities) *************************/
// The market's own zone is MARKET_TZ in ./market-clock, the one copy every caller shares.
export const CentralTimeZone: string = 'America/Chicago';

/*************************** MARKET HOLIDAY DATA (from holidayUtilities) *************************/
const allMarketHolidays: Map< string, string > = new Map< string, string >();

// 2016
allMarketHolidays.set( '2016-01-01', `New Years Day` );
allMarketHolidays.set( '2016-01-18', `Martin Luther King, Jr. Day` );
allMarketHolidays.set( '2016-02-15', `Washington's Birthday` );
allMarketHolidays.set( '2016-03-25', `Good Friday` );
allMarketHolidays.set( '2016-05-30', `Memorial Day` );
allMarketHolidays.set( '2016-07-04', `Independence Day` );
allMarketHolidays.set( '2016-09-05', `Labor Day` );
allMarketHolidays.set( '2016-11-24', `Thanksgiving Day` );
allMarketHolidays.set( '2016-12-26', `Christmas Day` );

// 2017
allMarketHolidays.set( '2017-01-02', `New Years Day` );
allMarketHolidays.set( '2017-01-16', `Martin Luther King, Jr. Day` );
allMarketHolidays.set( '2017-02-20', `Washington's Birthday` );
allMarketHolidays.set( '2017-04-14', `Good Friday` );
allMarketHolidays.set( '2017-05-29', `Memorial Day` );
allMarketHolidays.set( '2017-07-04', `Independence Day` );
allMarketHolidays.set( '2017-09-04', `Labor Day` );
allMarketHolidays.set( '2017-11-23', `Thanksgiving Day` );
allMarketHolidays.set( '2017-12-25', `Christmas Day` );

// 2018
allMarketHolidays.set( '2018-01-01', `New Years Day` );
allMarketHolidays.set( '2018-01-15', `Martin Luther King, Jr. Day` );
allMarketHolidays.set( '2018-02-19', `Washington's Birthday` );
allMarketHolidays.set( '2018-03-30', `Good Friday` );
allMarketHolidays.set( '2018-05-28', `Memorial Day` );
allMarketHolidays.set( '2018-07-04', `Independence Day` );
allMarketHolidays.set( '2018-09-03', `Labor Day` );
allMarketHolidays.set( '2018-11-22', `Thanksgiving Day` );
allMarketHolidays.set( '2018-12-05', `President Bush Funeral` );
allMarketHolidays.set( '2018-12-25', `Christmas Day` );

// 2019
allMarketHolidays.set( '2019-01-01', `New Years Day` );
allMarketHolidays.set( '2019-01-21', `Martin Luther King, Jr. Day` );
allMarketHolidays.set( '2019-02-18', `Washington's Birthday` );
allMarketHolidays.set( '2019-04-19', `Good Friday` );
allMarketHolidays.set( '2019-05-27', `Memorial Day` );
allMarketHolidays.set( '2019-07-04', `Independence Day` );
allMarketHolidays.set( '2019-09-02', `Labor Day` );
allMarketHolidays.set( '2019-11-28', `Thanksgiving Day` );
allMarketHolidays.set( '2019-12-25', `Christmas Day` );

// 2020
allMarketHolidays.set( '2020-01-01', `New Years Day` );
allMarketHolidays.set( '2020-01-20', `Martin Luther King, Jr. Day` );
allMarketHolidays.set( '2020-02-17', `Washington's Birthday` );
allMarketHolidays.set( '2020-04-10', `Good Friday` );
allMarketHolidays.set( '2020-05-25', `Memorial Day` );
allMarketHolidays.set( '2020-07-03', `Independence Day` );
allMarketHolidays.set( '2020-09-07', `Labor Day` );
allMarketHolidays.set( '2020-11-26', `Thanksgiving Day` );
allMarketHolidays.set( '2020-12-25', `Christmas Day` );

// 2021
allMarketHolidays.set( '2021-01-01', `New Years Day` );
allMarketHolidays.set( '2021-01-18', `Martin Luther King, Jr. Day` );
allMarketHolidays.set( '2021-02-15', `Washington's Birthday` );
allMarketHolidays.set( '2021-04-02', `Good Friday` );
allMarketHolidays.set( '2021-05-31', `Memorial Day` );
allMarketHolidays.set( '2021-07-05', `Independence Day` );
allMarketHolidays.set( '2021-09-06', `Labor Day` );
allMarketHolidays.set( '2021-11-25', `Thanksgiving Day` );
allMarketHolidays.set( '2021-12-24', `Christmas Day` );

// 2022
allMarketHolidays.set( '2022-01-17', `Martin Luther King, Jr. Day` );
allMarketHolidays.set( '2022-02-21', `Washington's Birthday` );
allMarketHolidays.set( '2022-04-15', `Good Friday` );
allMarketHolidays.set( '2022-05-30', `Memorial Day` );
allMarketHolidays.set( '2022-06-20', `Juneteenth National Independence Day` );
allMarketHolidays.set( '2022-07-04', `Independence Day` );
allMarketHolidays.set( '2022-09-05', `Labor Day` );
allMarketHolidays.set( '2022-11-24', `Thanksgiving Day` );
allMarketHolidays.set( '2022-12-26', `Christmas Day` );

// 2023
allMarketHolidays.set( '2023-01-02', `New Years Day` );
allMarketHolidays.set( '2023-01-16', `Martin Luther King, Jr. Day` );
allMarketHolidays.set( '2023-02-20', `Washington's Birthday` );
allMarketHolidays.set( '2023-04-07', `Good Friday` );
allMarketHolidays.set( '2023-05-29', `Memorial Day` );
allMarketHolidays.set( '2023-06-19', `Juneteenth National Independence Day` );
allMarketHolidays.set( '2023-07-04', `Independence Day` );
allMarketHolidays.set( '2023-09-04', `Labor Day` );
allMarketHolidays.set( '2023-11-23', `Thanksgiving Day` );
allMarketHolidays.set( '2023-12-25', `Christmas Day` );

// 2024
allMarketHolidays.set( '2024-01-01', `New Years Day` );
allMarketHolidays.set( '2024-01-15', `Martin Luther King, Jr. Day` );
allMarketHolidays.set( '2024-02-19', `Washington's Birthday` );
allMarketHolidays.set( '2024-03-29', `Good Friday` );
allMarketHolidays.set( '2024-05-27', `Memorial Day` );
allMarketHolidays.set( '2024-06-19', `Juneteenth National Independence Day` );
allMarketHolidays.set( '2024-07-04', `Independence Day` );
allMarketHolidays.set( '2024-09-02', `Labor Day` );
allMarketHolidays.set( '2024-11-28', `Thanksgiving Day` );
allMarketHolidays.set( '2024-12-25', `Christmas Day` );

// 2025
allMarketHolidays.set( '2025-01-01', `New Years Day` );
allMarketHolidays.set( '2025-01-09', `National Day of Mourning - President Jimmy Carter` );
allMarketHolidays.set( '2025-01-20', `Martin Luther King, Jr. Day` );
allMarketHolidays.set( '2025-02-17', `Washington's Birthday` );
allMarketHolidays.set( '2025-04-18', `Good Friday` );
allMarketHolidays.set( '2025-05-26', `Memorial Day` );
allMarketHolidays.set( '2025-06-19', `Juneteenth National Independence Day` );
allMarketHolidays.set( '2025-07-04', `Independence Day` );
allMarketHolidays.set( '2025-09-01', `Labor Day` );
allMarketHolidays.set( '2025-11-27', `Thanksgiving Day` );
allMarketHolidays.set( '2025-12-25', `Christmas Day` );

// 2026
allMarketHolidays.set( '2026-01-01', `New Years Day` );
allMarketHolidays.set( '2026-01-19', `Martin Luther King, Jr. Day` );
allMarketHolidays.set( '2026-02-16', `Washington's Birthday` );
allMarketHolidays.set( '2026-04-03', `Good Friday` );
allMarketHolidays.set( '2026-05-25', `Memorial Day` );
allMarketHolidays.set( '2026-06-19', `Juneteenth National Independence Day` );
allMarketHolidays.set( '2026-07-03', `Independence Day` );
allMarketHolidays.set( '2026-09-07', `Labor Day` );
allMarketHolidays.set( '2026-11-26', `Thanksgiving Day` );
allMarketHolidays.set( '2026-12-25', `Christmas Day` );

// 2027 — computed from NYSE Rule 7.2, NOT yet checked against NYSE's published calendar. A human must confirm
// these (and the 2027 early close below) at nyse.com/markets/hours-calendars before relying on them.
// Juneteenth (Sat), Independence Day (Sun) and Christmas (Sat) are observed on the nearest weekday.
// Jan 1 2028 is a Saturday and, per Rule 7.2, is NOT observed on Fri Dec 31 2027.
allMarketHolidays.set( '2027-01-01', `New Years Day` );
allMarketHolidays.set( '2027-01-18', `Martin Luther King, Jr. Day` );
allMarketHolidays.set( '2027-02-15', `Washington's Birthday` );
allMarketHolidays.set( '2027-03-26', `Good Friday` );
allMarketHolidays.set( '2027-05-31', `Memorial Day` );
allMarketHolidays.set( '2027-06-18', `Juneteenth National Independence Day` );
allMarketHolidays.set( '2027-07-05', `Independence Day` );
allMarketHolidays.set( '2027-09-06', `Labor Day` );
allMarketHolidays.set( '2027-11-25', `Thanksgiving Day` );
allMarketHolidays.set( '2027-12-24', `Christmas Day` );

/*************************** MARKET EARLY CLOSES (1:00 PM ET) *************************/
// Days the regular session ends at 1:00 PM ET. Tracked from the rest of 2026 on; earlier years were never recorded.
const allMarketEarlyCloses: Map< string, string > = new Map< string, string >();

// 2026 — computed like 2027's and to be confirmed with them. Jul 3 is the observed Independence Day holiday, so Jul 2
// is a full day.
allMarketEarlyCloses.set( '2026-11-27', `Day after Thanksgiving` );
allMarketEarlyCloses.set( '2026-12-24', `Christmas Eve` );

// 2027 — computed, unconfirmed (see the 2027 holidays). Jul 3 is a Saturday, so there is no Jul 2 early close,
// and Dec 24 is the observed Christmas holiday.
allMarketEarlyCloses.set( '2027-11-26', `Day after Thanksgiving` );

/**
 * The last day the holiday and early-close tables above cover. Past it every weekday reads as a full trading day,
 * so extend both tables and move this date forward each year (apps/web/src/utils/market-clock.spec.ts warns 60
 * days ahead).
 */
export const MARKET_CALENDAR_LAST_DAY: string = '2027-12-31';

// The DatePicker disables a date by its local year/month/day, so each holiday is local midnight of that day.
export const marketHolidayDates: Date[] = [ ...allMarketHolidays.keys() ].map( ( dt: string ) =>
    fromSortableString( dt ).toJSDate()
);

export function isMarketHoliday( dateString: string ): boolean {
    return allMarketHolidays.has( dateString );
}

export function marketHolidayLabel( date: string ): string {
    return allMarketHolidays.get( date ) ?? `INVALID MARKET DATE: ${ date }`;
}

export function isMarketEarlyClose( dateString: string ): boolean {
    return allMarketEarlyCloses.has( dateString );
}

export function marketEarlyCloseLabel( date: string ): string | undefined {
    return allMarketEarlyCloses.get( date );
}

/*************************** DATE/TIME Constants *************************/
const MonthDayYearDateFormat: string = 'MMMM d, yyyy';
const DayMonthYearMinimalDateFormat: string = 'ddMMyy';
const YearMonthDayMinimalDateFormat: string = 'yyMMdd';

/**
 * A type definition for simplifying the API of the IDateTimeService
 */
export type DateTimeLike = DateTime | Date | number | string | undefined;

export function normalizeDateTime( value: DateTimeLike | undefined | null ): DateTime {
    let date: DateTime | null = null;

    const valueType: string = typeof value;

    // If the value passed in is not defined, then use the current date
    if ( valueType === 'undefined' ) {
        // If nothing was provided, assign the current date & time (in UTC)
        date = DateTime.utc();
    }
    // If the value passed in is a string, attempt to parse it using standard formats
    else if ( valueType === 'string' ) {
        const dateString: string = value as string;

        // Attempt to parse using the most likely format and move down the list (ISO, RFC2822, HTTP header, give up)
        const isoDate: DateTime = DateTime.fromISO( dateString, { setZone: true } );

        // If the string was successfully parsed as an ISO-compliant string, return it
        if ( isoDate.isValid ) {
            date = isoDate;
        }
        // Otherwise, attempt to parse using the standard US date format
        else {
            const monthDayYearDateFormat: DateTime = DateTime.fromFormat( dateString, MonthDayYearDateFormat, { setZone: true } );

            if ( monthDayYearDateFormat.isValid ) {
                date = monthDayYearDateFormat;
            } else {
                const isoRetry: DateTime = DateTime.fromISO( dateString, { setZone: true } );
                if ( isoRetry.isValid ) {
                    date = isoRetry;
                } else {
                    const rfc2822Date: DateTime = DateTime.fromRFC2822( dateString, { setZone: true } );
                    if ( rfc2822Date.isValid ) {
                        date = rfc2822Date;
                    }
                    else {
                        const httpHeaderDate: DateTime = DateTime.fromHTTP( dateString, { setZone: true } );
                        if ( httpHeaderDate.isValid ) {
                            date = httpHeaderDate;
                        }
                        console.warn( `[ dateTimeService ] unable to parse date string: '${ dateString }'` );
                    }
                }
            }
        }
    }
    else if ( valueType === 'number' ) {
        const dateFromTimestamp: DateTime = DateTime.fromMillis( value as number );

        // If the value resolves to a valid DateTime, return it
        if ( dateFromTimestamp.isValid ) {
            date = dateFromTimestamp;
        }
    }
    // Test to determine if the object passed in is an instance of the native JavaScript Date object
    else if ( value instanceof Date ) {
        date = DateTime.fromJSDate( value );
    }
    // Test to determine if the object passed in is already an instance of the DateTime object
    else if ( value instanceof DateTime || DateTime.isDateTime( value ) ) {
        date = value;
    }
    else {
        date = DateTime.fromObject( { year: 0, month: 0, day: 0 } );
    }

    return date!;
}

export function fromSortableString( value: string ): DateTime {
    const SortableDateFormat: string = 'yyyy-MM-dd';
    return DateTime.fromFormat( value, SortableDateFormat );
}

export function utcNow(): DateTime {
    return DateTime.utc();
}

export function localNow(): DateTime {
    return DateTime.local();
}

/*----------------------------------------------------------------------------------------------- */
/* ------------------------------------ FORMATTING FUNCTIONS ------------------------------------ */
/*----------------------------------------------------------------------------------------------- */

export function formatDateAsSortableString( value: DateTimeLike, isNormalized: boolean = false ): string {
    const SortableDateFormat: string = 'yyyy-MM-dd';

    let dt: DateTime;
    if ( isNormalized ) {
        dt = value as DateTime;
    } else {
        dt = normalizeDateTime( value );
    }

    return dt?.isValid ? dt.toFormat( SortableDateFormat ) : '';
}

export function formatDateAsMonthDayYearString( value: DateTimeLike | undefined | null, isNormalized: boolean = false ): string {
    let dt: DateTime;
    if ( isNormalized ) {
        dt = value as DateTime;
    } else {
        dt = normalizeDateTime( value );
    }

    return dt.isValid ? dt.toFormat( MonthDayYearDateFormat ) : '';
}

export function formatDateAsISOString( value: DateTimeLike, isNormalized: boolean = false ): string {
    let dt: DateTime;
    if ( isNormalized ) {
        dt = value as DateTime;
    } else {
        dt = normalizeDateTime( value );
    }

    return dt?.isValid ? dt.toISODate()! : '';
}

export function formatDateAsYearMonthDayMinimalString( value: DateTimeLike, isNormalized: boolean = false ): string {
    let dt: DateTime;
    if ( isNormalized ) {
        dt = value as DateTime;
    } else {
        dt = normalizeDateTime( value );
    }

    return dt.isValid ? dt.toFormat( YearMonthDayMinimalDateFormat ) : '';
}

export function formatDateAsDayMonthYearMinimalString( date?: DateTimeLike, isNormalized: boolean = false ): string {
    let dt: DateTime;
    if ( isNormalized ) {
        dt = date as DateTime ?? DateTime.now();
    } else {
        dt = normalizeDateTime( date ?? DateTime.now() );
    }

    return dt.isValid ? dt.toFormat( DayMonthYearMinimalDateFormat ) : '';
}

export function formatDateAsISO8601String( value: DateTimeLike, isNormalized: boolean = false ): string {
    let dt: DateTime;
    if ( isNormalized ) {
        dt = value as DateTime;
    } else {
        dt = normalizeDateTime( value );
    }

    return dt?.isValid ? `${ dt.toISODate()! }${ dt.toISOTime( { includePrefix: true } ) }` : '';
}

export function formatDateAsDayOfWeekMonthDayYearString( value: DateTimeLike | undefined | null, isNormalized: boolean = false ): string {
    let dt: DateTime;
    if ( isNormalized ) {
        dt = value as DateTime;
    } else {
        dt = normalizeDateTime( value );
    }

    return dt.isValid ? dt.toLocaleString( DateTime.DATE_MED_WITH_WEEKDAY ) : '';
}

const WEBINAR_KEY = 'webinars';

export function maxDateTime( topic?: string | undefined ): DateTime {
    let maxDate = utcNow();
    if ( topic && WEBINAR_KEY === topic ) {
        maxDate = maxDate.plus( { weeks: 3 } );
    }

    return maxDate;
}

/**
 * 'N Minute Read' for an HTML body. Parsed inertly (rank 51): the live-document `innerHTML` this used made the
 * browser download every image in the body and run its inline handlers, just to count characters.
 */
export function countTime( html: string ): string {
    return readingTimeLabel( summarizeHtml( html ) );
}
